import React from 'react';
import './Footer.css';
import logo from '../assets/images/logo.png'; // Adjust the path as necessary

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-column logo-section">
          <div className="logo-placeholder h-10 w-10 text-center" aria-hidden="true">
            <img src={logo} alt="logo" />
          </div>
          <p>Copyright © 2025 Learners Rider</p>
          <p>Powered by Learners Rider</p>
        </div>

        <div className="footer-column">
          <h4>Learn</h4>
          <ul>
            <li>Introduction</li>
            <li>Working with data</li>
            <li>Validating</li>
            <li>Testing</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>About</h4>
          <ul>
            <li>About me</li>
            <li>Certificate</li>
            <li>Testimonials</li>
            <li>Get in touch</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Newsletter</h4>
          <label htmlFor="newsletter-email" className="sr-only">Email address</label>
          <input id="newsletter-email" type="email" placeholder="Email address" />
          <button className="subscribe-btn">Subscribe</button>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-links">
          <a href="#">Privacy</a>
          <a href="#">Terms</a>
        </div>
        <div className="footer-socials">
          <a href="#" aria-label="Visit our Medium profile">M</a>
          <a href="#" aria-label="Follow us on Twitter">🐦</a>
          <a href="#" aria-label="Follow us on Facebook">f</a>
          <a href="#" aria-label="Connect with us on LinkedIn">in</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
